module.exports = __webpack_public_path__ + "img/layout_03_hover.39100613.svg";